module.exports = __webpack_public_path__ + "img/magesi-logo-icon.3c15a061.png";